import React, { useState } from 'react';

import Card from '../../shared/components/UIElements/Card';
import Button from '../../shared/components/FormElements/Button/Button';
import Input from '../../shared/components/FormElements/Input/Input';
import ErrorModal from '../../shared/components/UIElements/ErrorModal';
import LoadingSpinner from '../../shared/components/UIElements/LoadingSpinner';
import { useHttpClient } from '../../shared/hooks/http-hook';
import {
    VALIDATOR_EMAIL
  } from '../../shared/util/validator';
import { useForm } from '../../shared/hooks/form-hook';
import './Auth.css';

const Waitlist = () => {
    const [emailSent, setEmailSent] = useState();
    const { isLoading, error, sendRequest, clearError } = useHttpClient();
    const [formState, inputHandler] = useForm(
        {
          email: {
            value: '',
            isValid: false
          },
          reason: {
            value: '',
            isValid: true
          }
        },
        false
      );

    const waitlistSubmitHandler = async(event) => {
        event.preventDefault();

        const responseData = await sendRequest(process.env.REACT_APP_BACKEND_URL_USER+'/waitlist', 'POST',
        JSON.stringify({
            email: formState.inputs.email.value,
            reason: formState.inputs.reason.value
        }),
        {
            'Content-Type': 'application/json'
        }
        );

        setEmailSent(responseData.email);
    };

    if (emailSent) {
        return <div className='thank-you-message'><h3>Thank you for joining the waitlist!</h3><h3>Confirmation email has been sent to {emailSent}</h3></div>;
    }

    return (
        <React.Fragment>
        <ErrorModal error={error} onClear={clearError}/>
        <div className='loginpage-container'>
        {isLoading && <LoadingSpinner asOverlay />}
        <div className='vaceai-auth'>VACE.AI</div>
        <div className='loginpage-description'>
        </div>
        <Card className="authentication">
          <h3>Sign Up for Waitlist!</h3>
          <hr />
          <form onSubmit={waitlistSubmitHandler}>
            <Input
                element="input"
                id="email"
                type="email"
                label="Email Address"
                validators={[VALIDATOR_EMAIL()]}
                errorText="Please enter your email"
                onInput={inputHandler}
            />
            <Input 
                element="textarea"
                id="reason"
                label="Purpose (Optional)"
                placeholder="ex) To prepare for job interview at ###."
                validators={[]}
                onInput={inputHandler}
                initialValid={true}
                rows={3}
            />
            <div className="authentication-button-submit">
              <div className='submit-button'>
                <Button type="submit" disabled={!formState.isValid} transparent>
                <p style={{ color: 'white', marginBottom: 0, marginTop: 0 }}>Register</p>
                </Button>
              </div>
            </div>
          </form>
        </Card>
        </div>
        </React.Fragment>
    );
};

export default Waitlist;